export default __webpack_public_path__ + "static/media/blue_right-chevron_icon.414d16af.svg";